import { Container } from '@ui/wrapper'
import { SectionWrapper } from './style'
import DocumentArchive from '@components/document-archive/layout-01'

const EusipaMarketReportArea = ({ dataCurrent, dataArchive, ...rest }) => {
  return (
    <SectionWrapper {...rest}>
      <Container>
        <DocumentArchive dataCurrent={dataCurrent} dataArchive={dataArchive} />
      </Container>
    </SectionWrapper>
  )
}

export default EusipaMarketReportArea
